import { render, staticRenderFns, recyclableRender, components } from "./address.vue?vue&type=template&id=111e30f2&scoped=true&"
var renderjs
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=111e30f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111e30f2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/setting/address.vue"
export default component.exports